"use strict";

import Dialog from './dialog';
import FormConfirmDelete from './form_confirm_delete';
import FormConfirmRestore from './form_confirm_restore';
import FormFileSizeValidation from './form_file_size_validation';
import CourseSearch from './course_search';
import Search from './search';
import './nav';
import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';

// Keep the existing globals for legacy Blade scripts.
window.Dialog = Dialog;
window.FormConfirmDelete = FormConfirmDelete;
window.FormConfirmRestore = FormConfirmRestore;
window.FormFileSizeValidation = FormFileSizeValidation;
window.CourseSearch = CourseSearch;
window.Search = Search;
window.tippy = tippy;

new FormConfirmDelete();
new FormConfirmRestore();
new FormFileSizeValidation();
